<template>
  <div id="app">
    <trtc-call @close="close" v-if="myUserId && myUserId !== '' && herUserId && herUserId !== ''"
               :her-user-id="herUserId" :my-user-id="myUserId"></trtc-call>
  </div>
</template>

<script>
  import TrtcCall from './components/TrtcCall'
  import {getSDKAppID} from "./util/call";

  export default {
    data() {
      return {
        herUserId: null,
        myUserId: null,
        projectId: null
      }
    },
    components: {
      TrtcCall
    },
    methods: {
      close() {
        window.opener.postMessage('由iframe发送', '*');
        window.close();
      }
    },
    created() {
      try {
        navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        }).then(function(stream) {
          console.log('获得媒体流');
        }).catch(function(error) {
          console.log('getUserMedia错误:', error);
        });
      } catch (err) {}

      let sdkConfig = getSDKAppID();
      if (!sdkConfig) {
        this.$message.warning(`参数不正确`);
        return;
      }
      let query = this.$route.query;
      let {h: herUserId, m: myUserId, p: projectId} = query;
      if (!myUserId || myUserId.toString() === '' || !herUserId || herUserId.toString() === '' || !projectId || projectId.toString() === '') return
      this.myUserId = myUserId;
      this.herUserId = herUserId;
      this.projectId = projectId;

      window.onbeforeunload = () => {
        this.close()
      };

    },
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue